import { cookieService } from '../../../cookie.service.js';
/**
 * @description Idempotent function.
 * This is a slightly adapted version of code implementation that can be found in tinuiti docs on page 10:
 * https://drive.google.com/file/d/18Z5k6iUXflsA8hEZBhq-ot4K07NIjEF_/view
 */
export function tinuitiPixel() {
    const fpc = cookieService.getCookie('fpc');
    createCookie('fpc', fpc);
}
/* eslint-disable */
function create_UUID() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
/* eslint-enable */
function createCookie(name, value) {
    const uuid = !value || value === 'undefined' ? create_UUID() : value;
    cookieService.setCookie(name, uuid, 7);
}
